export enum FeatureFlag {
  AdvisorOnboarding = 'flagAdvisorOnboarding',
  CockpitNonEci = 'flagCockpitNonEci',
  AdvisorDirectory = 'flagAdvisorDirectory',
  AiExperienceOptIn = 'ai_experience_opt_in',
  ClientPortalRedesignAccountProfile = 'flagClientPortalRedesignAccountProfile',
  ClientPortalRedesignAccounts = 'flagClientPortalRedesignAccounts',
  ClientPortalRedesignDocuments = 'flagClientPortalRedesignDocuments',
  ClientPortalRedesignHome = 'flagClientPortalRedesignHome',
  ClientPortalRedesignInvestments = 'flagClientPortalRedesignInvestments',
  ClientPortalRedesignOnboarding = 'flagClientPortalRedesignOnboarding',
  ClientPortalRedesignPlanning = 'flagClientPortalRedesignPlanning',
  ClientPortalRedesignShell = 'flagClientPortalRedesignShell',
  ClientPortalRedesignTasks = 'flagClientPortalRedesignTasks',
  ClientPortalRedesignTax = 'flagClientPortalRedesignTax',
  ClientPortalRedesignYourTeam = 'flagClientPortalRedesignYourTeam',
  ConfirmationOpsNotes = 'flagConfirmationOpsNotes',
  ExtendDocumentExtractionPollingEnabled = 'flagExtendDocumentExtractionPollingEnabled',
  FlagServalSupport = 'flagServalSupport',
  GoldmanSachsCustodian = 'flagGoldmanSachsCustodian',
  InvestmentProposalsUploadFile = 'investmentProposalsUploadFile',
  InvestmentPortfolioReportingEmbed = 'flagSwimPortfolioReportingEmbedUserIds',
  InvestmentResearch = 'flagInvestmentResearch',
  LinkedBankAdvisorImport = 'flagLinkedBankAdvisorImport',
  ManagedInvestmentsImprovements = 'managedInvestmentsImprovements',
  PortfolioPageRevamp = 'flagPortfolioPageRevamp',
  ProfessionalContacts = 'flagProfessionalContacts',
  RetirementPlans = 'flagRetirementPlans',
  SchwabApiSync = 'flagSchwabApiSync',
  ServiceItems = 'service-items',
  SkewAutoReload = 'flagSkewAutoReload',
}
